<template>
  <div style="" class="father">
    <wty-permission v-if="wtypermiss_show" :who="'shoppermission'" :perssionData="perssionData" :tableList="tableList"
      :tableClumn="tableClumn"></wty-permission>
  </div>
</template>
<script>
import wtyPermission from "@/components/wty-permission.vue";
import {
  permissionMerchantList,
  getMerchantPermissList
} from "@/api/merchant.js";
export default {
  name: "peopleinfo",
  components: { wtyPermission },
  data() {
    return {
      tableList: [],
      perssionData: {},
      wtypermiss_show: true,
      tableClumn: [
        {
          prop: "merchant_id",
          align: "center",
          label: "店铺id",
          width: "200",
          fixed: "left"
        },
        {
          prop: "mch_name",
          align: "center",
          label: "店铺名称",
          width: "200",
          fixed: "left"
        }
      ]
    };
  },
  async mounted() {
    this.wtypermiss_show = false;
    const res = await getMerchantPermissList();
    this.perssionData = res;
    this.tableList = await permissionMerchantList();
    this.wtypermiss_show = true; /* */
  }
};
</script>
<style lang="less" scoped>
.father {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #fff;
  padding: 10px 10px 0 10px;
}
</style>
